import { FuseAnimate } from "@fuse";
import { AppBar, DialogActions, DialogContent, MenuItem, Table, TableBody, TableCell, TableHead, TableRow, TextField, Toolbar, Typography, withStyles } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import XAPPDialog from "app/Core/Components/Dialog/XAPPDialog";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as AppActions from "app/store/actions";
import withReducer from "app/store/withReducer";
import clsx from "clsx";
import _ from "lodash";
import MobileDetect from "mobile-detect";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import * as Actions from "./Store/Actions/CompartilharActions";
import reducer from "./Store/Reducers/CompartilharReducer";

const md = new MobileDetect(window.navigator.userAgent);

const styles = theme => ({
    anotherLine: {
        backgroundColor: theme.palette.type === "dark" ? "#303030" : "#D4D4D4"
    }
});

class CompartilharDocumentos extends XAPPComponent {

    state = {
        open: false,
        selected: [],
        idprofissional: null,
        idpessoaformulario: null
    };

    componentDidMount() {
        const { idprofissional, idpessoaformulario } = this.props;
        let AObj = Object.assign({ ...this.state });
        AObj.idprofissional = idprofissional;
        AObj.idpessoaformulario = idpessoaformulario;
        this.setState({ ...AObj });
        this.props.getCompartilharDocumento(this.props.xappRouteParams, this.props.idpessoaformulario);
    }

    componentDidUpdate(prevProps, prevState) {
        const { idprofissional, idpessoaformulario } = this.props;
        const { compartilhardocumento = null } = this.props.Reducer;
        if (!prevState.open && this.state.open && !_.isNull(compartilhardocumento) && compartilhardocumento.idpessoaformulario === idpessoaformulario) {
            this.setState(_.set({ ...this.state }, "selected", compartilhardocumento.formulario[idprofissional]));
        }

        if (this.props.Reducer.error) {
            this.props.showMessage({
                message: this.props.Reducer.error,
                variant: "error"
            });
            this.props.Reducer.error = null;
        }
        if (this.props.Reducer.warning) {
            this.props.showMessage({
                message: this.props.Reducer.warning,
                variant: "warning"
            });
            this.props.Reducer.warning = null;
        }
        if (this.props.Reducer.info) {
            this.props.showMessage({
                message: this.props.Reducer.info,
                variant: "success"
            });
            this.props.Reducer.info = null;
            this.openDialog();
        }
    }

    openDialog = (_AValue = false) => {
        this.setState(_.set({ ...this.state }, "open", _AValue));
    };

    getProfissionais = () => {
        const { profissionaisempresa = null } = this.props.Reducer;
        const { selected } = this.state;
        let AResponse = [];
        if (!_.isNull(profissionaisempresa)) {
            profissionaisempresa.forEach(x => {
                if (!_.isNull(selected) && _.findIndex(selected, { idpessoaformulario: x.idpessoaformulario }) < 0) {
                    AResponse.push({ "idpessoaformulario": x.idpessoaformulario, "nome": x.nome });
                }
            });
        }
        return AResponse;
    };

    addSelected = (ev) => {
        let ASelected = Object.assign([], this.state.selected);
        const { profissionaisempresa = null } = this.props.Reducer;
        const AValue = _.find(profissionaisempresa, { idpessoaformulario: ev.target.value });
        ASelected.push({ "idpessoaformulario": AValue.idpessoaformulario, "nome": AValue.nome });
        this.setState(_.set({ ...this.state }, "selected", ASelected));
    };

    removeSelected = (_AValue) => {
        const { selected } = this.state;
        this.setState(_.set({ ...this.state }, "selected", selected.filter(x => x.idpessoaformulario !== _AValue)));
    };

    canBeSubmitted = () => {
        const { idprofissional = null, idpessoaformulario = null } = this.state;
        return (
            !_.isNull(idprofissional) && idprofissional !== "" &&
            !_.isNull(idpessoaformulario) && idpessoaformulario !== ""
        );
    };

    render() {
        const { idpessoaformulario = null, idprofissional = null, classes, xappRouteParams, saveCompartilharDocumento, sistemas } = this.props;
        const form = this.state;

        let AConfig = _.find(sistemas[xappRouteParams.empresa].configuracao, { "chave": "COMPARTILHAR_DOCUMENTO" });

        return (
            <React.Fragment>
                {!_.isNull(idpessoaformulario) && !_.isNull(idprofissional) && AConfig?.valor === "false" &&
                    <XAPPButton
                        tooltip={{ "title": "Compartilhar documentos", "placement": "top" }}
                        type="Icon"
                        className=""
                        onClick={() => this.openDialog(true)}
                        icon={"user_add"}
                    />
                }
                <XAPPDialog
                    id="CompartilharDocumentos"
                    open={form.open}
                    fullWidth
                    maxWidth={md.mobile() !== null ? "lg" : "sm"}
                    onClose={() => this.openDialog(false)}
                >
                    <AppBar position="static" elevation={1}>
                        <Toolbar className="flex w-full min-h-0">
                            <Typography variant="subtitle1 text-white">
                                {"Compartilhar documentos"}
                            </Typography>
                            <div style={{ flex: 1 }} />
                            <XAPPButton
                                className="p-8 "
                                icon="close"
                                type="icon"
                                iconProps="text-24 text-white"
                                onClick={() => this.openDialog(false)}
                            />
                        </Toolbar>
                    </AppBar>
                    <DialogContent classes={{ root: "p-16" }}>
                        <Typography className="text-16 font-400" color="textSecondary">
                            Permita que outros profissionais acessem os documentos criados por você adicionando-os a lista de compartilhamento abaixo:
                        </Typography>
                        <TextField
                            className="my-12 w-full"
                            label="Selecione"
                            id="profissionais"
                            name="profissionais"
                            onChange={this.addSelected}
                            variant="outlined"
                            fullWidth
                            select
                            InputLabelProps={{ shrink: false }}
                        >
                            {this.getProfissionais().map(x => (
                                <MenuItem key={x.idpessoaformulario} value={x.idpessoaformulario}>{x.nome}</MenuItem>
                            ))}
                        </TextField>
                        <FuseAnimate>
                            <Table className="min-w-full" aria-labelledby="tableTitle">
                                <TableHead>
                                    <TableRow className="h-64">
                                        <TableCell key={"id"} align={"center"} style={{ padding: "2px 12px 2px 12px" }}>ID</TableCell>
                                        <TableCell key={"profissional"} align={"center"} style={{ padding: "2px 12px 2px 12px" }}>Profissional</TableCell>
                                        <TableCell key={"remover"} align={"center"} style={{ padding: "2px 12px 2px 12px" }}>Remover</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {!_.isNull(form.selected) && form.selected?.length > 0 ?
                                        <>
                                            {form.selected.map((n, y) => {
                                                return (
                                                    <React.Fragment key={y}>
                                                        <TableRow className={clsx("", y % 2 === 0 && classes.anotherLine)}>
                                                            <TableCell key={"id"} align={"center"} style={{ padding: "2px 12px 2px 12px" }}>{n.idpessoaformulario}</TableCell>
                                                            <TableCell key={"profissional"} align={"center"} style={{ padding: "2px 12px 2px 12px" }}>{n.nome}</TableCell>
                                                            <TableCell key={"remover"} align={"center"} style={{ padding: "2px 12px 2px 12px" }}>
                                                                <XAPPButton
                                                                    className="p-8 "
                                                                    icon="delete"
                                                                    type="icon"
                                                                    iconProps="text-20 text-white"
                                                                    onClick={() => this.removeSelected(n.idpessoaformulario)}
                                                                />
                                                            </TableCell>
                                                        </TableRow>
                                                    </React.Fragment>
                                                );
                                            })}
                                        </>
                                        :
                                        <TableRow className="">
                                            <TableCell key={"registro"} colSpan={3} align={"center"} style={{ padding: "2px 12px 2px 12px" }}>
                                                {"Não existem registros cadastrados!"}
                                            </TableCell>
                                        </TableRow>
                                    }
                                </TableBody>
                            </Table>
                        </FuseAnimate>
                    </DialogContent>
                    <AppBar position="static" elevation={3} color="textSecondary">
                        <Toolbar className="flex w-full justify-end min-h-0">
                            <DialogActions className="">
                                <XAPPButton
                                    type="Button"
                                    className=""
                                    variant="contained"
                                    color="primary"
                                    disabled={!this.canBeSubmitted()}
                                    onClick={() => saveCompartilharDocumento(form, xappRouteParams)}
                                    iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                    icon={"save"}
                                    label={md.mobile() === null && md.tablet() === null ? "Salvar" : ""}
                                />
                            </DialogActions>
                        </Toolbar>
                    </AppBar>
                </XAPPDialog>
            </React.Fragment>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getCompartilharDocumento: Actions.getCompartilharDocumento,
        saveCompartilharDocumento: Actions.saveCompartilharDocumento,
        showMessage: AppActions.showMessage,
    }, dispatch);
}

function mapStateToProps({ Compartilhar, auth }) {
    return {
        Reducer: Compartilhar,
        sistemas: auth.user.data.settings.sistemas,
    };
}

export default withReducer("Compartilhar", reducer)(withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(CompartilharDocumentos))));